// extracted by mini-css-extract-plugin
module.exports = {"thanks":"thank-you_thanks__2G4KS","buttons":"thank-you_buttons__LK9Uu"};